// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"ForgotPassword_wrapperComponent__zkM4-","form":"ForgotPassword_form__-LyvM","actions":"ForgotPassword_actions__TmFV9"};